import React, { useState, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast, ToastContainer } from "react-toastify";
import LoginForm from "./LoginModule/LoginForm";
import Register from "./LoginModule/Register";
import { ThemeColorContextProvider } from "./Context/Theme";
import Landing from "./Landing/Landing";
import "react-toastify/dist/ReactToastify.css";
import Shop from "./Shop/Shop";
import ProductDetail from "./Shop/ProductDetail";
import Cart from "./Cart/Cart";
import ConfirmOrder from "./Cart/ConfirmOrder";
import Profile from "./Profile/Profile";
import MyOrder from "./Profile/MyOrder";
import MyEvents from "./Profile/MyEvents";
import Contact from "./contact/Contact";
import { useGetCartDataAPIQuery, useGetNotificationAPIQuery } from "./Api/api";
import { READ_ALL_NOTIFICATION, READ_CART_ITEMS } from "./Api/apiConstant";
import { setCart, clearCart } from "./Features/services/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import ForgotPassword from "./LoginModule/ForgotPassword";
import VerifyOTP from "./LoginModule/VerifyOTP";
import UpdatePassword from "./LoginModule/UpdatePassword";
import TokenExpiryDialog from "./components/TokenExpiryDialog";
import ScrollToTop from "./ScrollToTop";
import { storeEventName } from "./Utils/sessionutility";
import axios from "axios";
import DefaultPage from "./DefaultPage/defaultpage";
import API_URL from "./ServiceModule/Service";
import PaymentForm from "./Cart/PaymentForm";
import Search from "../src/search/search";
import Notifications from "./Profile/MyNotifications";
import Events from "./AllEvents/AllEventsLanding";
import TermsAndConditions from "./Policies/TermsAndConditions";
import PrivacyPolicy from "./Policies/PrivacyPolicy";
import { getLoggedIn, getToken, getUserId, getRoleId, removeAllCookies } from "./LoginModule/LoginUtility";
import { onMessage } from "firebase/messaging";
import { messaging, requestPermission, onMessageListener } from "./firebase/firebaseConfig";
import { useSearchParams } from "react-router-dom";
import { incrementNotificationCount } from "../src/Features/message/messageSlice";
import { skipToken } from '@reduxjs/toolkit/query/react';


function App() {
  const [searchParams] = useSearchParams();
  const adminPreview = searchParams.get("adminPreview"); // Replace with your query param
  const [isLoggedIn, setIsLoggedIn] = useState("");
  const [logout, setLogout] = useState(false);
  const [eventName, setEventName] = useState(sessionStorage.getItem("eventName") ? sessionStorage.getItem("eventName") : "");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = getUserId();
  const roleId = getRoleId();
  const [toastVisible, setToastVisible] = useState(false);

  const token = getToken()

  const { data: notifcation, refetch } = useGetNotificationAPIQuery(
    isLoggedIn
      ? {
        url: `${READ_ALL_NOTIFICATION}?user_id=${userId}&event_id=${0}`,
        token: token,
      }
      : skipToken,
    { refetchOnMountOrArgChange: true });

  // const token = useSelector((state) => state.auth.token);

  const cartId = sessionStorage.getItem("cartId");
  const eventId = sessionStorage.getItem("event_id");

  useState(() => {
    const isLoggedInData = getLoggedIn();
    setIsLoggedIn(isLoggedInData);
  }, [])



  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_Id");
    localStorage.removeItem("cartId");
    localStorage.removeItem("user");
    localStorage.removeItem("loggedIn");
    localStorage.removeItem("roleName");
    sessionStorage.removeItem("cartId");
    removeAllCookies()
    setIsLoggedIn("");
    dispatch(clearCart());
    setLogout(true);
    setIsLoggedIn("");
    navigate(`/events/${eventName}`);
  };

  useEffect(() => {
    requestPermission();
  }, []);
  // if ("serviceWorker" in navigator) {
  onMessage(messaging, (payload) => {
    const data = JSON.parse(payload?.data?.notification);
    if (data?.order_id) {
      notify(payload.notification, data?.order_id);
      // refetch();
      return
    }
    notify(payload.notification);
  });
  // }

  useEffect(() => {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data.type === 'INCREMENT_NOTIFICATION_COUNT') {
        // dispatch(incrementNotificationCount());
      }
    });
    setInterval(() => {
      dispatch(incrementNotificationCount());
    }, 3000);

  }, [dispatch]);

  const handleNotificationclick = (orderId) => {
    if (orderId) {
      sessionStorage.setItem("orderId", orderId);
      navigate(`/events/${eventName}/orders/${orderId}`);
      refetch();
    } else {
      navigate(`/events/${eventName}/notification`);
      refetch()
    }
  }

  const notify = (notification, orderId) => {
    if (!toastVisible) {
      setToastVisible(true);

      toast(
        <div
          style={{
            height: "100%",
            borderLeft: "5px solid green",
            display: "flex",
            alignItems: "center",
            paddingLeft: 5,
            cursor: "pointer",
          }}
          onClick={() => handleNotificationclick(orderId)}
          onMouseEnter={() => setToastVisible(true)}
        >
          {notification.image && (
            <div id="imageContainer">
              <img src={notification.image} width={100} />
            </div>
          )}
          <span style={{ fontWeight: "bold", color: "#000" }}>{notification.title}</span>

          <span style={{ marginLeft: 5 }}>
            {notification.body}
          </span>
        </div>
        , { containerId: "callFromApp", onClose: () => setToastVisible(false) });
    }
  }
  useEffect(() => {
    const url = new URL(window.location.href);
    const segments = url.pathname.split("/");
    const pathSegments = segments[segments.indexOf("events") + 1];
    if (pathSegments && pathSegments.length > 0) {
      const eventName = pathSegments;
      setEventName(eventName);
      storeEventName(eventName);
      sessionStorage.setItem("eventName", eventName);
    } else {
      setEventName("")
      sessionStorage.removeItem("eventName");
      navigate(`/events/`)
      console.error("No valid segments found in the URL");
    }
  }, []);

  useEffect(() => {
    let logoutTimer;
    const isLoggedInData = getLoggedIn();
    if (isLoggedInData) {
      const resetTimer = () => {
        if (logoutTimer) {
          clearTimeout(logoutTimer);
        }
        const includePages = ["/cart", "/notification", "/profile", "/confirm-order", "/orders", "/payment"];

        if (includePages.includes(window.location.pathname) && !adminPreview) {
          logoutTimer = setTimeout(() => {
            handleLogout();
          }, 30 * 60 * 1000);
        }
      };
      resetTimer();

      window.addEventListener("mousemove", resetTimer);
      window.addEventListener("keydown", resetTimer);

      return () => {
        window.removeEventListener("mousemove", resetTimer);
        window.removeEventListener("keydown", resetTimer);
      };
    } else {
      handleRefresh();
    }
  }, [isLoggedIn]);

  const handleRefresh = () => {
    const includePages = ["/cart", "/notification", "/profile", "/confirm-order", "/orders", "/payment"];
    if (includePages.includes(window.location.pathname) && !getLoggedIn() && roleId != 1 && roleId != 2 && !adminPreview) {
      localStorage.removeItem("token");
      localStorage.removeItem("user_Id");
      localStorage.removeItem("cartId");
      localStorage.removeItem("user");
      localStorage.removeItem("loggedIn");
      localStorage.removeItem("roleName");
      removeAllCookies()
      setIsLoggedIn("");
      navigate(`/events/${eventName}`);
    }
  };

  useEffect(() => {
    const fetchEventData = async () => {
      if (eventName) {
        try {
          const response = await axios.get(
            `${API_URL}/api/event/getEventNavigation?event_link=${eventName}`
          );
          if (response?.data) {
            sessionStorage.setItem(
              "preorderStartDate",
              response?.data?.preorder_start_date
            );
            sessionStorage.setItem("city_tax", response?.data?.city_tax);
            sessionStorage.setItem("state_tax", response?.data?.state_tax);
            sessionStorage.setItem(
              "preorderEndDate",
              response?.data?.preorder_end_date
            );
            sessionStorage.setItem("event_id", response?.data?.event_id);
            sessionStorage.setItem("eventTaxes", JSON.stringify(response?.data?.eventTaxes))
            sessionStorage.setItem("event_name", response?.data?.event_name);

          }
        } catch (error) {

          if (eventName !== "delivery-module" &&
            eventName !== "contact" &&
            eventName !== "terms&conditions" &&
            eventName !== "privacy-policy") {
            navigate(`/events/${eventName}/NotFound`);
            console.error("Error fetching event navigation:", error);
          }
        }
      }
    };

    fetchEventData();
  }, [eventName, navigate]);

  // const shouldSkip = cartId == null || cartId === "" || cartId === "null" || !userId || !eventId; 
  const {
    data: cartData,
    isSuccess,
    isError,
    error,
    isLoading,
  } = useGetCartDataAPIQuery(
    {
      url: `${READ_CART_ITEMS}cart_id=${cartId}&user_id=${userId}&event_id=${eventId}`,
      token: token,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !cartId
    }
  );
  useEffect(() => {
    if (isError) {
      if (error?.data?.message === "Token is not provided") {
        if (eventName !== "delivery-module" && !adminPreview) {
          handleLogout();
        }
      }

    }
  }, [isError, error])

  useEffect(() => {


    if (userId && token) {
      if (isSuccess) {
        const { cartItems, bundles } = cartData?.data;
        const totalQuantity = [
          ...cartItems.map((item) => item.quantity),
          ...bundles.map((bundle) => bundle.quantity),
        ].reduce((sum, qty) => sum + qty, 0);
        const cartItem = {
          items: cartData?.data?.cartItems || [],
          bundle: cartData?.data?.bundles || [],
          orderSummary: cartData?.data?.orderSummary || {},
          totalAmount: 0,
          totalQuantity: totalQuantity || 0,
        };
        dispatch(setCart(cartItem));
      }
      else if (
        isSuccess &&
        cartData?.data?.cartItems.length === 0 &&
        cartData?.data?.bundles.length === 0
      ) {
        dispatch(
          setCart({
            items: [],
            bundle: [],
            orderSummary: {},
            totalAmount: 0,
            totalQuantity: 0,
          })
        );
      }
    } else {
      dispatch(
        setCart({
          items: [],
          bundle: [],
          orderSummary: {},
          totalAmount: 0,
          totalQuantity: 0,
        })
      );
    }
  }, [
    cartData,
    isSuccess,
    isError,
    userId,
    token,
    dispatch,
    eventId,
    navigate,
  ]);

  return (
    <>
      {/* <TokenExpiryDialog /> */}
      <ThemeColorContextProvider>
        <ScrollToTop />
        <Routes>
          <Route
            path="/events/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route
            path="/events/privacy-policy"
            element={<PrivacyPolicy />}
          />
          <Route path={`/events/${eventName}/terms-and-conditions`} element={<TermsAndConditions />} />
          <Route path={`/events/${eventName}/privacy-policy`} element={<PrivacyPolicy />} />
          <Route path={`/events`} element={<Events />} />
          <Route path={`/events/${eventName}/login`} element={<LoginForm />} />
          <Route path={`/events/${eventName}/register`} element={<Register />} />
          {
            eventName &&
            <Route
              path={`/events/${eventName}`}
              element={eventName == "contact" ? <Contact /> : eventName == "terms&conditions" ? <TermsAndConditions /> : eventName == "privacy-policy" ? <PrivacyPolicy /> : <Landing />}
            />
          }
          <Route path={`/events/${eventName}/shop`} element={<Shop />} />
          <Route path={`/events/${eventName}/search`} element={<Search />} />
          <Route

            path={`/events/${eventName}/product-detail/:productId`}
            element={<ProductDetail />}
          />
          <Route path={`/events/${eventName}/cart`} element={<Cart />} />
          <Route

            path={`/events/${eventName}/confirm-order`}
            element={<ConfirmOrder />}
          />
          <Route path={`/events/${eventName}/profile`} element={<Profile />} />
          <Route path={`/events/${eventName}/myEvents`} element={<MyEvents />} />
          <Route path={`/events/${eventName}/orders/:id`} element={<MyOrder />} />
          <Route path={`/events/${eventName}/notification`} element={<Notifications />} />
          <Route path={`/events//events`} element={<MyEvents />} />
          <Route path={`/events/${eventName}/contact`} element={<Contact />} />
          <Route path={`/events/contact`} element={<Contact />} />
          <Route

            path={`/events/${eventName}/forgotPassword`}
            element={<ForgotPassword />}
          />
          <Route path={`/events/${eventName}/verifyOTP`} element={<VerifyOTP />} />
          <Route

            path={`/events/${eventName}/UpdatePassword`}
            element={<UpdatePassword />}
          />
          <Route path={`/events/${eventName}/NotFound`} element={<DefaultPage />} />
          <Route path={`/events/${eventName}/payment`} element={<PaymentForm />} />
        </Routes>
      </ThemeColorContextProvider>
      <ToastContainer containerId={"callFromApp"} autoClose={2000} />
    </>
  );
}

export default App;
